export const ENVIRONMENT_CODES = {
  DEV: 'dev',
  UAT: 'uat',
  STG: 'stg',
  LIVE: 'live'
};
//# sourceMappingURL=enviromentCodes.js.map